import React from 'react'
import PropTypes from 'prop-types'
import { Button, TextField } from '@material-ui/core'
import styles from './EmailRedirectUrlInputAndValidation.icss'

//	Quick check for valid page link.
const validateUrl = url => url.indexOf('page.link/') !== -1 && url.indexOf('https://') === 0

class EmailRedirectUrlInputAndValidation extends React.Component {
	constructor(props) {
		super(props)
		this.state = { url: '' }
		this.handleUrlChange = this.handleUrlChange.bind(this)
		this.handleUrlSubmit = this.handleUrlSubmit.bind(this)
		this.validateUrl = this.validateUrl.bind(this)
	}

	validateUrl(url) {
		const urlValidationError = !validateUrl(url)
		this.setState({ urlValidationError })
		return !urlValidationError
	}

	handleUrlChange(e) {
		const url = e.target.value
		this.setState({ url })
		this.validateUrl(url)
	}

	handleUrlSubmit() {
		const hasAttemptedToSubmit = true
		this.setState({ hasAttemptedToSubmit })
		if (this.validateUrl(this.state.url)) {
			const hasSubmitted = true
			this.setState({ hasSubmitted })
			this.props.urlHandler(this.state.url)
		}
	}

	render() {
		return (
			<section className={`${styles.container} ${styles.emailSurround}`}>
				<div className={styles.emailField}>
					<TextField
						name="url"
						fullWidth
						label={this.props.label}
						value={this.state.url}
						onChange={this.handleUrlChange}
					/>
				</div>
				{this.state.urlValidationError && this.state.hasAttemptedToSubmit && (
					<div>
						<span className={styles.validationError}>{this.context.translate('Please enter a valid redirect url')}</span>
					</div>
				)}
				<Button
					onClick={this.handleUrlSubmit}
					classes={{ root: styles.button + (!this.state.hasSubmitted && !this.state.urlValidationError && this.state.url !== '' ? ` ${styles.buttonValid}` : ''), label: styles.label }}
					disabled={this.state.hasSubmitted}
				>
					{this.props.buttonText}
				</Button>
			</section>
		)
	}
}

EmailRedirectUrlInputAndValidation.propTypes = {
	urlHandler: PropTypes.func.isRequired,
	buttonText: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired
}

EmailRedirectUrlInputAndValidation.contextTypes = {
	translate: PropTypes.func
}

export default EmailRedirectUrlInputAndValidation



// WEBPACK FOOTER //
// ./src/components/EmailRedirectUrlInputAndValidation.jsx